export const ManagePractitionerV3TrackingIds = {
  createExceptionModalSaveBtn: 'create-exception-modal-save-btn',
  createExceptionModalCancelBtn: 'create-exception-modal-cancel-btn',
};
